import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ConfirmDialog as ModalDelete, captureException } from '@playbookux/playbook-web-core';
import { useMutation } from '@apollo/client';
import { ConsentBody } from './styles';
import {
  ZeroState,
} from '../../../styles';
import {
  NO_ITEMS_MESSAGE_MAP,
  TEMPLATE_TYPES,
} from '../../../constants';
import ConsentFormLine from './consent-line';
import { DELETE_CONSENT_FORM_BY_ID } from '../../../../../../core/graphql/consent-forms';

const ConsentFormManagementComponentBody = ({
  consentForms,
  refetchConsentForms,
  refetchConsentFormsRequired,
}) => {
  const [currentForm, setCurrentForm] = useState(undefined);

  const [
    deleteFormMutation,
    {
      loading: loadingDelete,
      error: errorDelete,
    },
  ] = useMutation(
    DELETE_CONSENT_FORM_BY_ID,
  );

  const handleCloseModalDelete = () => {
    setCurrentForm(undefined);
  };

  const handleConfirmDeleteTemplate = async () => {
    try {
      await deleteFormMutation({
        variables: {
          id: currentForm.id,
        },
      });
    } catch (exception) {
      captureException('ERROR_DELETING_CONSENT_FORM', exception);
    }

    refetchConsentForms();
    refetchConsentFormsRequired();
    handleCloseModalDelete();
  };

  const handleView = (selectedConsentForm) => {
    window.open(selectedConsentForm.filePath, '_blank').focus();
  };

  const handleOpenModalDelete = (selectedForm) => {
    setCurrentForm(selectedForm);
  };

  return (
    <>
      <ConsentBody>
        {
          _.isEmpty(consentForms) && (
            <ZeroState fluid>
              {NO_ITEMS_MESSAGE_MAP[TEMPLATE_TYPES.CONSENT]}
            </ZeroState>
          )
        }
        {
          consentForms.map((consentForm) => (
            <ConsentFormLine
              key={consentForm.id}
              consentForm={consentForm}
              handleDelete={handleOpenModalDelete}
              handleView={handleView}
            />
          ))
        }
      </ConsentBody>
      <ModalDelete
        show={currentForm}
        title={`Do you want to delete the template "${currentForm?.name}"?`}
        warning="Warning: This cannot be undone"
        confirmText="Yes, delete form"
        cancelText="Cancel, keep form"
        handleClose={handleCloseModalDelete}
        handleConfirm={handleConfirmDeleteTemplate}
        errorMessage={errorDelete && 'Something went wrong while deleting'}
        loading={loadingDelete}
      />
    </>
  );
};

ConsentFormManagementComponentBody.propTypes = {
  consentForms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  refetchConsentForms: PropTypes.func.isRequired,
  refetchConsentFormsRequired: PropTypes.func.isRequired,
};

export default ConsentFormManagementComponentBody;
